import React, { Component } from "react";
import Fade from "react-reveal";
import p1 from "./sir.jpg"
import p2 from "./pic.jpeg"
import p3 from "./gana.jpg"
import p4 from "./nidhu.jpg"
import p5 from "./suda.jpg"
import p6 from "./pic6.jpeg"
import p7 from "./pic8.jpg"
import altpic from "./pic5.jpg"
class About extends Component {
  render() {

    return (
      <section id="about">
        
        <Fade duration={1000}>
          <div className="row">

            <div className="nine columns main-col">
            <h2>Mentor</h2>
              <h2>Dr. Venkataraman D</h2>
              <div className="row">
                <div className="columns contact-details">
                  <h2>Contact Details</h2>
                  <p className="address">
                    <br />
                    <span>
                      AMRITA VISHWA VIDYAPEETHAM
                      <br />
                      COIMBATORE
                    </span>
                  </p>
                </div>
                <div className="columns download">
                  <p>
                    <a href="https://www.amrita.edu/faculty/d-venkat" className="button">
                      Profile
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="three columns">
              <img
                className="profile-pic"
                src={p1}
                alt={altpic}
              />
            </div>

            <div className="nine columns main-col">
            <h2>Developer & DevOps</h2>
              <h2>Balaji D</h2>
              <div className="row">
                <div className="columns contact-details">
                  <h2>Contact Details</h2>
                  <p className="address">
                    <br />
                    <span>
                      AMRITA VISHWA VIDYAPEETHAM
                      <br />
                      COIMBATORE
                    </span>
                    <br />
                    <span>9659198181</span>
                    <br />
                    <span>balajidass07@gmail.com</span>
                  </p>
                </div>
                <div className="columns download">
                  <p>
                    <a href="https://balajidass07.github.io/" className="button">
                      Profile
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="three columns">
              <img
                className="profile-pic"
                src={p2}
                alt={altpic}
              />
            </div>


            <div className="nine columns main-col">
            <h2>Developer & DevOps</h2>
              <h2>Ganapathi Subramanyam Jayam</h2>
              <div className="row">
                <div className="columns contact-details">
                  <h2>Contact Details</h2>
                  <p className="address">
                    <br />
                    <span>
                      AMRITA VISHWA VIDYAPEETHAM
                      <br />
                      COIMBATORE
                    </span>
                    <br />
                    <span>7730098120</span>
                    <br />
                    <span>jayam.ganapathi12@gmail.com</span>
                  </p>
                </div>
                <div className="columns download">
                  <p>
                    <a href="https://ganapathi12.github.io/" className="button">
                    Profile
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="three columns">
              <img
                className="profile-pic"
                src={p3}
                alt={altpic}
              />
            </div>


            <div className="nine columns main-col">
            <h2>Developer & DevOps</h2>
              <h2>Nidharshan A</h2>
              <div className="row">
                <div className="columns contact-details">
                  <h2>Contact Details</h2>
                  <p className="address">
                    <br />
                    <span>
                      AMRITA VISHWA VIDYAPEETHAM
                      <br />
                      COIMBATORE
                    </span>
                    <br />
                    <span>8098151227</span>
                    <br />
                    <span>nidharshan2001@gmail.com</span>
                  </p>
                </div>
                <div className="columns download">
                  <p>
                    <a href="https://github.com/nidharshan3401" className="button">
                      Profile
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="three columns">
              <img
                className="profile-pic"
                src={p4}
                alt={altpic}
              /> 
            </div>


            <div className="nine columns main-col">
            <h2>Developer & Tester</h2>
              <h2>Akula Sudhamshu</h2>
              <div className="row">
                <div className="columns contact-details">
                  <h2>Contact Details</h2>
                  <p className="address">
                    <br />
                    <span>
                      AMRITA VISHWA VIDYAPEETHAM
                      <br />
                      COIMBATORE
                    </span>
                    <br />
                    <span>9494996474</span>
                    <br />
                    <span>sudhamshakula6@gmail.com</span>
                  </p>
                </div>
                <div className="columns download">
                  <p>
                    <a href="https://akula0611.github.io/" className="button">
                    Profile
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="three columns">
              <img
                className="profile-pic"
                src={p5}
                alt={altpic}
              />
            </div>


            <div className="nine columns main-col">
            <h2>Developer & Tester</h2>
              <h2>Nishita Dash</h2>
              <div className="row">
                <div className="columns contact-details">
                  <h2>Contact Details</h2>
                  <p className="address">
                    <br />
                    <span>
                      AMRITA VISHWA VIDYAPEETHAM
                      <br />
                      COIMBATORE
                    </span>
                    <br />
                    <span>7013865358</span>
                    <br />
                    <span>nishitacse73081@gmail.com</span>
                  </p>
                </div>
                <div className="columns download">
                  <p>
                    <a href="https://github.com/nishitadash" className="button">
                    Profile
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="three columns">
              <img
                className="profile-pic"
                src={p6}
                alt={altpic}
              />
            </div>


            <div className="nine columns main-col">
            <h2>Developer & Tester</h2>
            
              <h2>Asritha V</h2>
              <div className="row">
                <div className="columns contact-details">
                  <h2>Contact Details</h2>
                  <p className="address">
                    <br />
                    <span>
                      AMRITA VISHWA VIDYAPEETHAM
                      <br />
                      COIMBATORE
                    </span>
                    <br />
                    <span>8374699501</span>
                    <br />
                    <span>asrithavemireddy986@gmail.com</span>
                  </p>
                </div>
                <div className="columns download">
                  <p>
                    <a href="https://github.com/asrithareddy" className="button">
                    Profile
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="three columns">
              <img
                className="profile-pic"
                src={p7}
                alt={altpic}
              />
            </div>
          </div>
        </Fade>
      </section>
    );
  }
}

export default About;
